import { AppStatusConfig } from '../models/application-status-config.interface';
import { COMMENT_CARD_TYPES } from '../enums/comment-card-types.enum';

export class CommentCardConfig {
	static COMMENT_CARDS: { [commentCardType: string]: AppStatusConfig } = {
		[COMMENT_CARD_TYPES.Default]: {
			id: 0,
			title: 'Default',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		[COMMENT_CARD_TYPES.ProgramRules]: {
			id: 0,
			title: 'Rules Message',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: ''
		},
		[COMMENT_CARD_TYPES.Message]: {
			id: 0,
			title: 'Comment',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: ''
		},
		[COMMENT_CARD_TYPES.InternalNote]: {
			id: 0,
			title: 'Internal Note',
			color: 'blue',
			adminColor: 'darkBlue',
			icon: ''
		},
		[COMMENT_CARD_TYPES.COURSE]: {
			id: 0,
			title: '',
			color: 'blue',
			adminColor: 'darkBlue',
			icon: ''
		},
		[COMMENT_CARD_TYPES.APPLICATION_EXPENSE]: {
			id: 0,
			title: '',
			color: 'gray',
			adminColor: 'gray',
			icon: ''
		},
		[COMMENT_CARD_TYPES.APPLICATION_EXCEPTION]: {
			id: 0,
			title: 'APPLICATION EXCEPTION',
			color: 'green',
			adminColor: 'green',
			icon: ''
		},
		[COMMENT_CARD_TYPES.PARTICIPANT_EXCEPTION]: {
			id: 0,
			title: 'PARTICIPANT EXCEPTION',
			color: 'green',
			adminColor: 'green',
			icon: ''
		},
		[COMMENT_CARD_TYPES.PARTICIPANT_ALERT]: {
			id: 0,
			title: 'PARTICIPANT ALERT',
			color: 'grayLight',
			adminColor: 'yellow',
			icon: ''
		},
		[COMMENT_CARD_TYPES.APPLICATION_TOTALS]: {
			id: 0,
			title: 'Totals',
			color: 'gray',
			adminColor: 'gray',
			icon: ''
		},
		[COMMENT_CARD_TYPES.SYSTEM_MESSAGE]: {
			id: 0,
			title: 'SYSTEM MESSAGE',
			color: 'gray',
			adminColor: 'gray',
			icon: ''
		},
		[COMMENT_CARD_TYPES.PAYMENT]: {
			id: 0,
			title: 'PAYMENT',
			color: 'blue',
			adminColor: 'blue',
			icon: ''
		},
		[COMMENT_CARD_TYPES.STOP_PAYMENT]: {
			id: 0,
			title: 'STOPPED',
			color: 'red',
			adminColor: 'red',
			icon: ''
		},
		[COMMENT_CARD_TYPES.REFUND]: {
			id: 0,
			title: 'REFUND',
			color: 'gray',
			adminColor: 'gray',
			icon: ''
		},
		[COMMENT_CARD_TYPES.PARTICIPANT_HISTORY]: {
			id: 0,
			title: '',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: ''
		},
		[COMMENT_CARD_TYPES.GENERAL]: {
			id: 0,
			title: 'CREATED',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: ''
		},
		[COMMENT_CARD_TYPES.APPEAL_REASON]: {
			id: 0,
			title: 'BASIS FOR RECONSIDERATION',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: ''
		},
		[COMMENT_CARD_TYPES.APPLICATION_EXCEPTION_DELETED]: {
			id: 0,
			title: 'APPLICATION EXCEPTION DELETED',
			color: 'red',
			adminColor: 'red',
			icon: ''
		},
	};
}
